import { render } from "./QuestionFeedbackList.vue?vue&type=template&id=95c32276&scoped=true"
import script from "./QuestionFeedbackList.vue?vue&type=script&lang=js"
export * from "./QuestionFeedbackList.vue?vue&type=script&lang=js"

import "./QuestionFeedbackList.vue?vue&type=style&index=0&id=95c32276&scoped=true&lang=scss"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c32276"]])

export default __exports__